import apiClient from './client';

export interface SalesFilters {
  customer?: number;
  year?: number;
  month?: number;
  empresa?: number;
}

export interface CustomerSummaryItem {
  customerId: number;
  customerName: string;
  ventas: {
    [year: string]: number;
  };
}

export interface CustomerProductSummaryItem {
  productId: number;
  productCode: string;
  productName: string;
  unidades: {
    [year: string]: number;
  };
  ventasTotales: {
    [year: string]: number;
  };
}

export const salesService = {
  async getCustomerSummary(filters: SalesFilters): Promise<CustomerSummaryItem[]> {
    const { data } = await apiClient.get<CustomerSummaryItem[]>('/clientes/ventas-anuales', {
      params: filters,
    });
    return data;
  },

  async getCustomerProducts(filters: SalesFilters): Promise<CustomerProductSummaryItem[]> {
    const { data } = await apiClient.get<CustomerProductSummaryItem[]>('/clientes/productos-comprados', {
      params: filters,
    });
    return data;
  },
};
